import ClassLabel from "./ClassLabel";
import Pictures from "./Pictures";
import PublishButton from "./PublishButton";

const Main = () => {
  return (
    <div className="h-full space-y-3 lg:space-y-5">
      <div className="flex justify-between items-center">
        <ClassLabel />
        <div className="w-full lg:w-1/3">
          <PublishButton />
        </div>
      </div>
      <Pictures />
    </div>
  );
};

export default Main;
